class ImageCarouselSlider extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    const carouselEl = this.querySelector('.ics__carousel');
    if (!carouselEl) return;

    this.slider = new Flickity(carouselEl, {
      cellAlign: 'center',
      contain: false,
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
      rightToLeft: theme.config.rtl,
      accessibility: true
    });

    this.panels = Array.from(this.querySelectorAll('.ics__panel'));
    this.prevBtn = this.querySelector('.ics__btn--prev');
    this.nextBtn = this.querySelector('.ics__btn--next');

    this.slider.on('change', (index) => {
      this.panels.forEach((panel) => panel.setAttribute('hidden', ''));
      if (this.panels[index]) this.panels[index].removeAttribute('hidden');
      this.updateButtons(index);
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.slider.previous());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.slider.next());
    }

    this.updateButtons(0);

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', () => {
        if (this.slider) this.slider.resize();
      });
    }
  }

  updateButtons(index) {
    if (this.prevBtn) this.prevBtn.disabled = index === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.slider && index === this.slider.slides.length - 1;
  }

  disconnectedCallback() {
    if (this.slider) this.slider.destroy();
  }
}

if (!customElements.get('image-carousel-slider')) {
  customElements.define('image-carousel-slider', ImageCarouselSlider);
}
